import { getAPIBaseURL } from './helpers'
import { getData, postData, deleteData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

/**
 * Upload media (image or video)
 * Note: Authentication handled via cookies (withCredentials: true in request.js)
 */
export const uploadCenterMedia = async (file, caption = '') => {
  const url = `${base()}/center/media`
  const formData = new FormData()
  formData.append('file', file)
  if (caption) {
    formData.append('caption', caption)
  }
  
  // Don't pass token in headers - authentication via cookies
  const headers = {}
  
  const res = await postData(url, headers, formData)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

/**
 * Get center's media
 * Note: Authentication handled via cookies (withCredentials: true in request.js)
 */
export const listMyCenterMedia = async (type = '') => {
  const url = `${base()}/center/media${type ? `?type=${type}` : ''}`
  // Don't pass token in headers - authentication via cookies
  const headers = {}
  
  const res = await getData(url, headers, {})
  if (res.error === '') {
    const data = res.result.data?.data || res.result.data
    // Ensure we return an array
    return { status: res.result.status, data: Array.isArray(data) ? data : [] }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message, data: [] }
}

/**
 * Delete media
 * Note: Authentication handled via cookies (withCredentials: true in request.js)
 */
export const deleteCenterMedia = async (mediaId) => {
  const url = `${base()}/center/media/${mediaId}`
  // Don't pass token in headers - authentication via cookies
  const headers = {}
  
  const res = await deleteData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

